import { Alert } from "@mantine/core";

import { IconExclamationMark } from "@tabler/icons-react";

import { TextWrapper } from "@/components/TextWrapper";

interface MissingPaymentMethodBannerProps {
  onDismiss?: () => void;
}

/**
 * Warns that the client has no primary payment method and links to Billing → Insurance.
 */
export default function MissingPaymentMethodBanner({ onDismiss }: MissingPaymentMethodBannerProps) {
  return (
    <Alert
      mb="md"
      color="orange"
      variant="light"
      onClose={onDismiss}
      withCloseButton={Boolean(onDismiss)}
      title="Primary payment method missing!"
      data-testid="missing-payment-method-banner"
      icon={<IconExclamationMark size={16} stroke={2.5} />}
      styles={{
        root: {
          backgroundColor: "var(--mantine-color-orange-0)",
          border: "none",
        },
        title: { color: "var(--mantine-color-orange-9)", fontWeight: 700 },
        icon: {
          border: "2px solid var(--mantine-color-orange-9)",
          color: "var(--mantine-color-orange-9)",
          borderRadius: "50%",
          width: "16px",
          height: "16px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        },
      }}
    >
      <TextWrapper c="dark.9">
        This client is missing a primary payment method. Update self-pay or insurance in Billing
        Insurance to continue billing.
      </TextWrapper>
    </Alert>
  );
}
